import React from 'react';
import Select from 'react-select';
import { Button, Card, CardBody, FormGroup, Input, Table } from 'reactstrap';
import { LANGUAGE_ARRAY_WITH_STRING } from 'utils/constants';

const AddUpdateTranslations = ({ formik, name = 'translations' }) => {
  const { values, setFieldValue } = formik;

  const translations = values[name] || [];

  const addRow = () => {
    setFieldValue(name, [...translations, { language: '', title: '' }]);
  };

  const removeRow = (index) => {
    const updated = translations.filter((_, i) => i !== index);
    setFieldValue(name, updated);
  };

  const updateRow = (index, key, value) => {
    const updated = [...translations];
    updated[index] = {
      ...updated[index],
      [key]: value,
    };
    setFieldValue(name, updated);
  };

  return (
    <Card style={{ marginBottom: '100px' }}>
      <CardBody>
        <div className="d-flex  align-items-center justify-content-between">
          <h4 className="mb-0">Translations</h4>
          <Button size="sm" color="success" onClick={addRow}>
            + Add Translation
          </Button>
        </div>

        <table className="table table-bordered mt-4">
          <thead>
            <tr>
              <th style={{ width: '30%' }}>Language</th>
              <th style={{ width: '50%' }}>Title</th>
              <th style={{ width: '20%' }} className="text-center">
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {translations.length > 0 ? (
              translations.map((item, index) => (
                <tr key={index}>
                  {/* Language */}
                  <td>
                    <FormGroup>
                      <Select
                        options={LANGUAGE_ARRAY_WITH_STRING}
                        placeholder="Select language..."
                        value={LANGUAGE_ARRAY_WITH_STRING.find((opt) => opt.value === item.language)}
                        onChange={(selected) => updateRow(index, 'language', selected?.value || '')}
                      />
                    </FormGroup>
                  </td>

                  {/* Title */}
                  <td>
                    <FormGroup>
                      <Input
                        type="text"
                        placeholder="Enter title"
                        value={item.title || ''}
                        onChange={(e) => updateRow(index, 'title', e.target.value)}
                      />
                    </FormGroup>
                  </td>

                  {/* Delete */}
                  <td className="text-center">
                    <Button color="danger" size="sm" onClick={() => removeRow(index)}>
                      Delete
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="bg-white text-center text-xl" style={{ padding: '60px 0px' }}>
                  <div className="">No data found</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CardBody>
    </Card>
  );
};

export default AddUpdateTranslations;
